import PropTypes from 'prop-types';
import React from 'react';
import EmptyStates from '../../components/empty-states';
import withTranslate from '../../hoc/with-translate';

const MembersPlaceholder = ({ t }) =>
  <EmptyStates title={t('members-placeholder.title')} content={t('members-placeholder.content')}/>;

MembersPlaceholder.propTypes = {
  t: PropTypes.func,
};

export default withTranslate(MembersPlaceholder);



// WEBPACK FOOTER //
// ./app/components/members-placeholder/members-placeholder.js